// src/services/voiceFlowConstraintService.js
// 語音流程日期/時間限制 — admin REST 客戶端
// OpenSpec change: add-date-time-constraints (Phase 7)
//
// Backend 路徑：/api/voice-flows/:flowId/constraints[/:id][/toggle]
// 回應 shape：{ success, data, warnings? }
import { apiRequest } from './apiService';

const handle = async (promise, errMsg) => {
  try {
    const response = await promise;
    return response.data; // 後端 body
  } catch (error) {
    throw new Error(error.response?.data?.message || errMsg);
  }
};

const voiceFlowConstraintService = {
  list: (flowId) =>
    handle(
      apiRequest('get', `voice-flows/${flowId}/constraints`),
      '無法取得限制列表'
    ),

  create: (flowId, payload) =>
    handle(
      apiRequest('post', `voice-flows/${flowId}/constraints`, payload),
      '建立限制失敗'
    ),

  update: (flowId, id, payload) =>
    handle(
      apiRequest('put', `voice-flows/${flowId}/constraints/${id}`, payload),
      '更新限制失敗'
    ),

  remove: (flowId, id) =>
    handle(
      apiRequest('delete', `voice-flows/${flowId}/constraints/${id}`),
      '刪除限制失敗'
    ),

  toggle: (flowId, id) =>
    handle(
      apiRequest('patch', `voice-flows/${flowId}/constraints/${id}/toggle`),
      '切換啟用狀態失敗'
    ),

  // Phase C — enqueue BreezeVoice → sox → ASR → S3 + GSM pipeline.
  // Returns { success, data: { constraintId, audioStatus: 'pending' } } at 202.
  // Subsequent state changes arrive via the 'constraint_audio_status' socket event.
  regenerateAudio: (flowId, id) =>
    handle(
      apiRequest('post', `voice-flows/${flowId}/constraints/${id}/regenerate-audio`),
      '觸發語音生成失敗'
    )
};

export default voiceFlowConstraintService;
